export class ReportingConfigurationSettings {

    HideReportToArchiveButton: boolean;
}